import React, { Fragment, useEffect, useState } from 'react';
import {
	Avatar,
	Box,
	Chip,
	ClickAwayListener,
	Grow,
	ListItemAvatar,
	ListItemText,
	MenuItem,
	MenuList,
	Paper,
	Popper,
	Tooltip,
	Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetails } from '../../../config/utils';

export const KpiOverallProgress: React.FC<any> = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const userDetail = getUserDetails();
	const [loader, setLoader] = useState<boolean>(false);
	useEffect(() => {}, []);
	return <Box className='performance-team-goals'>Overall Progress</Box>;
};
